import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "h-full flex flex-col border-[3px] border-cebai-grey-light rounded-2xl" }
const _hoisted_2 = { class: "flex flex-wrap items-start p-6" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "h-8 w-8 my-1 mr-2"
}
const _hoisted_5 = {
  key: 1,
  class: "h-8 w-8 my-1 mr-2"
}
const _hoisted_6 = {
  key: 2,
  class: "h-8 w-4 my-1 mr-4"
}
const _hoisted_7 = {
  key: 3,
  class: "h-8 w-8 my-1 mr-2"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  class: "h-8 w-8 my-1 mr-2"
}
const _hoisted_10 = {
  key: 1,
  class: "h-8 w-8 my-1 mr-2"
}
const _hoisted_11 = { class: "flex flex-1 justify-between min-w-[82%]" }
const _hoisted_12 = { class: "min-w-0 break-words" }
const _hoisted_13 = {
  key: 0,
  class: "mr-3 text-lg"
}
const _hoisted_14 = ["href"]
const _hoisted_15 = { class: "mr-3 text-lg" }
const _hoisted_16 = {
  key: 2,
  class: "text-xs uppercase mb-1"
}
const _hoisted_17 = { key: 3 }
const _hoisted_18 = { class: "flex items-center mt-2" }
const _hoisted_19 = { class: "ml-1 md:ml-2" }
const _hoisted_20 = { class: "ml-4 md:ml-6" }
const _hoisted_21 = { class: "ml-1 sm:ml-2" }
const _hoisted_22 = { class: "ml-4 md:ml-6" }
const _hoisted_23 = { class: "ml-1 md:ml-2" }
const _hoisted_24 = { class: "mt-1" }
const _hoisted_25 = {
  key: 0,
  class: "pb-3 px-6 text-sm"
}
const _hoisted_26 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_27 = { class: "p-4 flex-1" }
const _hoisted_28 = { class: "mb-2 flex justify-center" }
const _hoisted_29 = { class: "w-8" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2 text-center" }, "Fetching themes...", -1)
const _hoisted_31 = { class: "inline-flex flex-wrap items-start justify-start" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "mt-20 mb-2 flex justify-center" }
const _hoisted_35 = { class: "w-8" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "mb-20 text-center" }, "Fetching learning spark...", -1)
const _hoisted_37 = { class: "rounded-xl overflow-hidden h-full" }
const _hoisted_38 = { class: "flex justify-center mt-3" }
const _hoisted_39 = {
  key: 1,
  class: "flex flex-row justify-center mt-8 mb-6"
}
const _hoisted_40 = { class: "mt-6 text-base" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TwitterLogoIcon = _resolveComponent("TwitterLogoIcon")!
  const _component_MediumIcon = _resolveComponent("MediumIcon")!
  const _component_UKCoachingIcon = _resolveComponent("UKCoachingIcon")!
  const _component_BlogIcon = _resolveComponent("BlogIcon")!
  const _component_TrophyIcon = _resolveComponent("TrophyIcon")!
  const _component_PeopleIcon = _resolveComponent("PeopleIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_TwitterReplyIcon = _resolveComponent("TwitterReplyIcon")!
  const _component_TwitterRetweetIcon = _resolveComponent("TwitterRetweetIcon")!
  const _component_TwitterLikeIcon = _resolveComponent("TwitterLikeIcon")!
  const _component_AddIcon = _resolveComponent("AddIcon")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Markdown = _resolveComponent("Markdown")!
  const _component_LoadingIcon = _resolveComponent("LoadingIcon")!
  const _component_CreateIdea = _resolveComponent("CreateIdea")!
  const _component_ModalContent = _resolveComponent("ModalContent")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ChallengeSparksListItem = _resolveComponent("ChallengeSparksListItem")!
  const _component_RefreshIcon = _resolveComponent("RefreshIcon")!
  const _component_Guidance = _resolveComponent("Guidance")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.item.learningType === 'resources')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_ctx.item.origin === 'twitter')
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_TwitterLogoIcon, { class: "fill-current" })
                  ]))
                : (_ctx.item.origin === 'medium')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_component_MediumIcon, { class: "fill-current" })
                    ]))
                  : (_ctx.isUKCoachingResource)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(_component_UKCoachingIcon, { class: "fill-current" })
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createVNode(_component_BlogIcon, { class: "fill-current" })
                      ]))
            ]))
          : _createCommentVNode("", true),
        (_ctx.item.learningType === 'caseStudies')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_ctx.item.type === 'Sport')
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(_component_TrophyIcon, { class: "fill-current" })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createVNode(_component_PeopleIcon, { class: "fill-current" })
                  ]))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            ('uri' in _ctx.item)
              ? (_openBlock(), _createElementBlock("h4", _hoisted_13, [
                  _createElementVNode("a", {
                    class: "block",
                    href: _ctx.item.uri,
                    target: "_blank",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleLinkClick && _ctx.handleLinkClick(...args)))
                  }, _toDisplayString(_ctx.item.title), 9, _hoisted_14)
                ]))
              : (_ctx.item.learningType === 'caseStudies')
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: { name: 'case-study', params: { id: _ctx.item.id } }
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("h4", _hoisted_15, _toDisplayString(_ctx.item.title), 1)
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true),
            (_ctx.item.source)
              ? (_openBlock(), _createElementBlock("p", _hoisted_16, [
                  _createTextVNode(_toDisplayString(_ctx.item.source) + " ", 1),
                  (_ctx.item.author)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode("| " + _toDisplayString(_ctx.item.author), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.item.public_metrics)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", null, [
                      _createVNode(_component_TwitterReplyIcon, { class: "fill-current" })
                    ]),
                    _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.item.public_metrics.reply_count), 1),
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_TwitterRetweetIcon, { class: "fill-current" })
                    ]),
                    _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.item.public_metrics.retweet_count), 1),
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_TwitterLikeIcon, { class: "fill-current" })
                    ]),
                    _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.item.public_metrics.like_count), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_AppButton, {
              id: `add-learning-${_ctx.index}`,
              type: "outline",
              padding: "narrow",
              onClick: _ctx.showIdeaModal
            }, {
              iconBefore: _withCtx(() => [
                _createVNode(_component_AddIcon, { class: "fill-current" })
              ]),
              _: 1
            }, 8, ["id", "onClick"])
          ])
        ])
      ]),
      (_ctx.context)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            (_ctx.isShowingContext)
              ? (_openBlock(), _createElementBlock("p", _hoisted_26, [
                  _createVNode(_component_Markdown, { source: _ctx.context }, null, 8, ["source"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "text-sm text-cebai-primary",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleContext && _ctx.toggleContext(...args)))
            }, [
              (_ctx.isShowingContext)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" Hide context ")
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" Show context ")
                  ], 64))
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_27, [
        (_ctx.item.isLoading)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_LoadingIcon)
                ])
              ]),
              _hoisted_30
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_31, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.initialThemes, (theme, themeIndex) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: themeIndex,
                    class: "m-1 bg-cebai-grey-lighter hover:bg-cebai-grey-dark hover:text-cebai-base-light px-2.5 py-1 rounded-md text-sm font-robotoMedium",
                    onClick: () => _ctx.handleThemeClick(theme.label)
                  }, _toDisplayString(theme.label), 9, _hoisted_32))
                }), 128)),
                (_ctx.isShowingExtraThemes)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.extraThemes, (theme, themeIndex) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: themeIndex,
                        class: "m-1 bg-cebai-grey-lighter hover:bg-cebai-grey-dark hover:text-cebai-base-light px-2.5 py-1 rounded-md text-sm font-robotoMedium",
                        onClick: () => _ctx.handleThemeClick(theme.label)
                      }, _toDisplayString(theme.label), 9, _hoisted_33))
                    }), 128))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.extraThemes.length)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "px-2 pt-2.5 text-sm text-cebai-grey-dark",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleExtraThemes && _ctx.toggleExtraThemes(...args)))
                  }, [
                    (_ctx.isShowingExtraThemes)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(" See less ")
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" See more ")
                        ], 64))
                  ]))
                : _createCommentVNode("", true)
            ], 64))
      ])
    ]),
    _createVNode(_component_Modal, {
      modelValue: _ctx.isShown.addIdea,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isShown.addIdea) = $event)),
      close: () => _ctx.closeModal('addIdea')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ModalContent, {
          close: () => _ctx.closeModal('addIdea'),
          title: "Develop your idea"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CreateIdea, {
              "close-modal": () => _ctx.closeModal('addIdea'),
              description: _ctx.item.description,
              notes: _ctx.item.uri
            }, null, 8, ["close-modal", "description", "notes"])
          ]),
          _: 1
        }, 8, ["close"])
      ]),
      _: 1
    }, 8, ["modelValue", "close"]),
    (_ctx.selectedTheme)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          modelValue: _ctx.isShown.learningSpark,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.isShown.learningSpark) = $event)),
          close: () => _ctx.closeModal('learningSpark')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ModalContent, {
              close: () => _ctx.closeModal('learningSpark'),
              title: "Learning spark",
              class: "md:max-w-lg"
            }, {
              default: _withCtx(() => [
                (_ctx.isLoadingLearningPrompts)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _createVNode(_component_LoadingIcon)
                        ])
                      ]),
                      _hoisted_36
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_ctx.learningSparks.length > 0)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.learningSparks, (learningSpark, i) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: i,
                                class: "w-full"
                              }, [
                                _createElementVNode("div", _hoisted_37, [
                                  _createVNode(_component_ChallengeSparksListItem, {
                                    spark: learningSpark,
                                    index: i
                                  }, null, 8, ["spark", "index"])
                                ])
                              ]))
                            }), 128)),
                            _createElementVNode("div", _hoisted_38, [
                              _createVNode(_component_AppButton, {
                                type: "secondary",
                                onClick: _cache[4] || (_cache[4] = () => _ctx.handleThemeClick(_ctx.selectedTheme))
                              }, {
                                iconBefore: _withCtx(() => [
                                  _createVNode(_component_RefreshIcon, { class: "mr-2 fill-current" })
                                ]),
                                default: _withCtx(() => [
                                  _createTextVNode(" Refresh ")
                                ]),
                                _: 1
                              })
                            ])
                          ], 64))
                        : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                            _createVNode(_component_Guidance, null, {
                              text: _withCtx(() => [
                                _createTextVNode(" Sorry, we were unable to generate a spark for you. ")
                              ]),
                              _: 1
                            })
                          ]))
                    ], 64)),
                _createElementVNode("p", _hoisted_40, [
                  _createTextVNode(" Learn more about "),
                  _createElementVNode("button", {
                    class: "text-cebai-primary font-robotoMedium hover:underline hover:decoration-cebai-primary hover:underline-offset-4",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleLearnMoreClick && _ctx.handleLearnMoreClick(...args)))
                  }, _toDisplayString(_ctx.selectedTheme), 1)
                ])
              ]),
              _: 1
            }, 8, ["close"])
          ]),
          _: 1
        }, 8, ["modelValue", "close"]))
      : _createCommentVNode("", true)
  ], 64))
}